<template>
  <span class="icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="4" y="3" width="3" height="10" rx="1" fill="#FF8800" />
      <rect x="9" y="3" width="3" height="10" rx="1" fill="#FF8800" />
    </svg>
  </span>
</template>
